export interface AdminCardConfig {
  title: string;
  description: string;
  route: string;
  featureFlag?: 'enableCoTeacherAdminUI';
}

export const ADMIN_CARDS: AdminCardConfig[] = [
  {
    title: 'Manage Co-Teachers',
    description: 'Search classrooms and manage co-teacher membership for authorized staff.',
    route: '/administrator/co-teachers',
    featureFlag: 'enableCoTeacherAdminUI',
  },
];

export function getVisibleAdminCards(enableCoTeacherAdminUI: boolean): AdminCardConfig[] {
  return ADMIN_CARDS.filter((card) => {
    if (card.featureFlag === 'enableCoTeacherAdminUI') {
      return enableCoTeacherAdminUI;
    }
    return true;
  });
}
